import React, { useEffect, useState } from 'react';
import { Box, Heading } from '@hover/blueprint';

const TEXTS = [
  'measurements',
  'visualizations',
  'estimates',
  'ordering',
  'privacy protection',
  'collaboration',
];

const HomePageBetterTexts: React.FC = () => {
  const [currentText, setCurrentText] = useState<number>(0);

  useEffect(() => {
    const unsub = setInterval(() => {
      setCurrentText(prv => (prv + 1 >= TEXTS.length ? 0 : prv + 1));
    }, 1000);

    return () => clearInterval(unsub);
  }, []);

  return (
    <Box d="flex" alignItems="center" mb={{ base: 0, tablet: 800 }}>
      <Heading
        style={{ marginBottom: 0 }}
        size={{ base: 500, tablet: 600, desktop: 700 }}
      >
        Better &nbsp;
      </Heading>
      <Heading
        style={{ marginBottom: 0 }}
        size={{ base: 500, tablet: 600, desktop: 700 }}
      >
        {TEXTS[currentText]}
      </Heading>
    </Box>
  );
};

export default HomePageBetterTexts;
